import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, catchError, of } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../../../core/components/navmenu/navmenu.service';
import { ListaInspeccionPeriodoViewModel } from '../inspecciones.types';
import { PeriodoInspeccionService } from '../inspecciones.service';
import { PeriodoCamService } from '../../datosbasicos/periodocam.service';
import { CampaniasGlobalService } from 'src/app/components/_campanias/services/global-campanias.service';

@Component({
    selector: 'app-inspecciones-wrapper',
    templateUrl: './inspecciones-wrapper.component.html',
})
export class InspeccionesWrapperComponent extends ComponentBase implements OnInit {
    searching = false;
    listaInspeccionesPeriodo: ListaInspeccionPeriodoViewModel;
    successMessage = 'Datos guardados correctamente';

    esVigenteConSolicitudes = false;

    private periodoId = 0;
    private route = '/mantenimiento/periodos/inspecciones';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.periodoId = parseInt(id);
            this.getSiVigenteConSolicitudes(this.periodoId);
            this.getListaInspecciones();
        } else {
            console.error('Parámetro Id inexistente en la ruta');
        }
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        protected authService: AuthService,
        private periodoCamService: PeriodoCamService,
        private campaniasGlobalService: CampaniasGlobalService,
        protected notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        protected exceptionHandler: ExceptionManager,
        private inspeccionesService: PeriodoInspeccionService,
        private navMenuService: NavMenuService,
        private router: Router,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        // no-op
    }

    /**
     * Obtiene la lista de inspecciones del periodo
     * @return void
     */
    private getListaInspecciones(): void {
        if (!this.periodoId) {
            return;
        }
        this.campaniasGlobalService
            .getListaInspeccionesDePeriodo(this.periodoId)
            .pipe(
                tap((results: ListaInspeccionPeriodoViewModel) => {
                    this.searching = true;
                    this.listaInspeccionesPeriodo = results;
                    this.navMenuService.updateMenuServiceForPeriodo(this.periodoId);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.searching = false;
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Método que invoca a la API para comprueba si el periodo es vigente y tiene solicitudes de campaña asociadas.
     * @param id number
     * @return void
     */
    private getSiVigenteConSolicitudes(id: number): void {
        this.periodoCamService
            .getPeriodoEsVigente(id)
            .pipe(
                tap((p: boolean) => {
                    this.esVigenteConSolicitudes = p;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    onAdd($event: Event): void {
        //$event?.stopPropagation();
        this.router.navigate([this.route + '/' + this.periodoId + '/create']);
    }

    onEdit(itemId: number | null): void {
        this.router.navigate([this.route + '/' + this.periodoId + '/edit', itemId]);
    }

    onDelete(id: number) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.inspeccionesService.delete(id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Inspección eliminada correctamente');
                        this.getListaInspecciones();
                    },
                    error: () => {
                        this.addErrorMessage('Error al borrar la Inspección');
                    },
                });
            },
        });
    }

    get formInvalid(): boolean {
        return this.listaInspeccionesPeriodo == null || this.listaInspeccionesPeriodo.InspeccionPeriodoCollection?.length === 0;
    }

    get esPeriodoFinalizado(): boolean {
        const hoy = new Date();
        if (!this.listaInspeccionesPeriodo?.PeriodoFechaFin) {
            return false;
        }
        const fechaFinPeriodo = new Date(this.listaInspeccionesPeriodo.PeriodoFechaFin);
        return hoy >= fechaFinPeriodo;
    }
}
